import React, { Component } from 'react';
import './FloatBall.scss';

export default class Name extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  componentWillUnmount() {}
  onFeedbackNav = () => {
    this.props.onClick();
  };
  render() {
    return (
      <React.Fragment>
        <div className="float-ball-wrapper" onClick={this.onFeedbackNav}></div>
      </React.Fragment>
    );
  }
}
